// SPDX-License-Identifier: AGPL-3.0-or-later

import {formatAssetUploadExtensions, formatKnownAnimatedAssetExtensions} from '@fluxer/constants/src/AssetFormatPolicy';
import {THE_OTHER_PLATFORM} from '@fluxer/constants/src/ExternalPlatformConstants';
import {PREMIUM_PRODUCT_FULL_NAME, PREMIUM_PRODUCT_NAME, PRODUCT_NAME} from './ProductConstants';

export {PREMIUM_PRODUCT_FULL_NAME, PREMIUM_PRODUCT_NAME, PRODUCT_NAME};
export const DESKTOP_PRODUCT_NAME = `${PRODUCT_NAME} Desktop`;
export const PRODUCT_API_NAME = `${PRODUCT_NAME} API`;
export const PRODUCT_HQ_COMMUNITY_NAME = `${PRODUCT_NAME} HQ`;
export const CANARY_RELEASE_CHANNEL_NAME = `${PRODUCT_NAME} Canary`;
export const VOICE_PROVIDER_NAME = 'LiveKit';
export const PAYMENT_PROVIDER_NAME = 'Stripe';
export const BLUESKY_PROVIDER_NAME = 'Bluesky';
export const APP_STORE_NAME = 'App Store';
export const GOOGLE_PLAY_NAME = 'Google Play';
export const MACOS_SYSTEM_SETTINGS_NAME = 'System Settings';
export const MACOS_PRIVACY_AND_SECURITY_SETTINGS_NAME = 'Privacy & Security';
export const MACOS_CAMERA_PERMISSION_NAME = 'Camera';
export const MACOS_INPUT_MONITORING_PERMISSION_NAME = 'Input Monitoring';
export const MACOS_MICROPHONE_PERMISSION_NAME = 'Microphone';
export const MACOS_SCREEN_RECORDING_PERMISSION_NAME = 'Screen Recording';
export const PIX_PAYMENT_METHOD = 'Pix';
export const UPI_PAYMENT_METHOD = 'UPI';
export const BLIK_PAYMENT_METHOD = 'BLIK';
export const MB_WAY_PAYMENT_METHOD = 'MB WAY';
export const SUPPORT_EMAIL = 'support@fluxer.app';
export const SUPPORT_EMAIL_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const I18N_EMAIL = 'i18n@fluxer.app';
export const I18N_EMAIL_MAILTO = `mailto:${I18N_EMAIL}`;
export const EXAMPLE_DOMAIN = 'example.com';
export const EXAMPLE_URL = `https://${EXAMPLE_DOMAIN}`;
export const EXAMPLE_CALLBACK_URL = `${EXAMPLE_URL}/callback`;
export const EXAMPLE_EMAIL = 'name@example.com';
export const EXAMPLE_PERSONAL_EMAIL = 'marty@example.com';
export const EXAMPLE_USERNAME_TAG = 'Username#0000';
export const EXAMPLE_REPORT_EMAIL = 'you@example.com';
export const EXAMPLE_REPORT_USER_TAG = 'username#1234';
export const EXAMPLE_INVITE_CODE = 'abcDEF12';
export const EXAMPLE_VERIFICATION_CODE = 'ABCD-1234';
export const EXAMPLE_FLUXER_TAG = 'Marty_McFly';
export const EXAMPLE_CUSTOM_URL_SLUG = 'your-custom-url';
export const EXAMPLE_BOT_NAME = 'BotName';
export const EXAMPLE_CHANNEL_NAME = 'new-channel';
export const EXAMPLE_GENERAL_CHANNEL_NAME = 'general';
export const EXAMPLE_USERNAME_MENTION = '@username';
export const EXAMPLE_FLUXER_TAG_FULL = 'Username#0000';
export const FLUXER_TAG_LABEL = 'CoretTag';
export const VISIONARY_LIFETIME_BADGE_LABEL = 'Visionary #42';
export const FLUXER_TAG_MIN_WITH_ZERO_LABEL = '#0000';
export const FLUXER_TAG_MIN_STANDARD_LABEL = '#0001';
export const FLUXER_TAG_MAX_LABEL = '#9999';
export const LINK_PREVIEW_EXAMPLE_URL = 'https://coret.cloud';
export const EXAMPLE_MESSAGE_LINK = `${LINK_PREVIEW_EXAMPLE_URL}/channels/...`;
export const EXAMPLE_GIF_URLS = `${EXAMPLE_URL}/gif1.gif\n${EXAMPLE_URL}/gif2.gif`;
export const THE_OTHER_PLATFORM_TEMPLATE_EXAMPLE_URL = `https://${THE_OTHER_PLATFORM.toLowerCase()}.new/abcd1234`;
export const DOWNLOAD_PAGE_URL = 'https://coret.cloud/download';
export const WINDOWS_DOWNLOAD_URL = 'https://coret.cloud/coret-brand/downloads/Coret-Setup-1.7.1.exe';
export const LINUX_DOWNLOAD_URL = 'https://coret.cloud/coret-brand/downloads/Coret-Linux-1.7.1.tar.gz';
export const ANDROID_INSTALL_URL = 'https://coret.cloud/coret-brand/downloads/Coret-Android-1.1.1.apk';
export const DESKTOP_DOWNLOAD_URL = DOWNLOAD_PAGE_URL;
export const FLUXER_DOCS_DOMAIN = 'fluxer.dev';
export const FLUXER_DOCS_URL = `https://${FLUXER_DOCS_DOMAIN}`;
export const FLUXER_BLUESKY_HANDLE = '@fluxer.app';
export const SPLASH_IRC_SERVER = 'irc.fluxer.com:6667';
export const YOUTUBE_PROVIDER_NAME = 'YouTube';
export const EVERYONE_MENTION = '@everyone';
export const HERE_MENTION = '@here';
export const SILENT_MENTION = '@silent';
export const ROLE_MENTION = '@role';
export const ROLES_MENTION = '@roles';
export const RECENT_MENTIONS_RETENTION_DAYS = 7;
export const SEND_MESSAGES_PERMISSION = 'SEND_MESSAGES';
export const ATTACH_FILES_PERMISSION = 'ATTACH_FILES';
export const ANIMATED_ICON_FEATURE = 'ANIMATED_ICON';
export const ANIMATED_BANNER_FEATURE = 'ANIMATED_BANNER';
export const STATIC_IMAGE_FORMATS = formatAssetUploadExtensions('avatar', {animatedAllowed: false});
export const STATIC_IMAGE_WITH_AVIF_FORMATS = formatAssetUploadExtensions('splash');
export const ANIMATED_IMAGE_FORMATS = formatAssetUploadExtensions('avatar');
export const BACKGROUND_MEDIA_FORMATS = 'JPG, PNG, GIF, WebP, MP4';
export const ANIMATED_AVATAR_FORMATS = formatKnownAnimatedAssetExtensions('avatar');
export const AVIF_FORMAT_LABEL = 'AVIF';
export const CUSTOM_SOUND_FORMATS = 'MP3, WAV, OGG, M4A, AAC, FLAC, Opus, WebM';
export const IMAGE_MAX_SIZE_LABEL = '10MB';
export const BACKGROUND_MEDIA_MAX_SIZE_LABEL = '10MB';
export const CUSTOM_SOUND_MAX_SIZE_LABEL = '2MB';
export const CUSTOM_SOUND_MAX_DURATION_LABEL = '5.2 seconds';
export const AVATAR_RECOMMENDED_SIZE_LABEL = '512×512px';
export const BANNER_MINIMUM_SIZE_LABEL = '680×240px';
export const BANNER_ASPECT_RATIO_LABEL = '17:6';
export const WIDE_IMAGE_ASPECT_RATIO_LABEL = '16:9';
export const MFA_CODE_DIGIT_COUNT = 6;
export const FLUXER_TAG_DIGIT_COUNT = 4;
export const PHONE_VERIFICATION_LIMIT = 2;
export const PHONE_VERIFICATION_WINDOW_DAYS = 30;
export const ADULT_CONTENT_MINIMUM_AGE = 18;
export const UNLIMITED_USER_LIMIT = 0;
